import React from "react";

const Dashboard = () => {
	return (
		<div className="bg-gray-900 flex">
			{/* Sidebar */}
			<aside className="w-64 bg-white shadow-lg hidden md:block">
				<div className="p-6 font-bold text-xl border-b">My Dashboard</div>
				<nav className="p-4 space-y-3">
					<a className="block px-4 py-2 rounded hover:bg-gray-200" href="#">
						Home
					</a>
					<a className="block px-4 py-2 rounded hover:bg-gray-200" href="#">
						Users
					</a>
					<a className="block px-4 py-2 rounded hover:bg-gray-200" href="#">
						Reports
					</a>
					<a className="block px-4 py-2 rounded hover:bg-gray-200" href="#">
						Settings
					</a>
				</nav>
			</aside>

			{/* Main Content */}
			<div className="flex-1">
				{/* Header */}
				<header className="bg-white shadow p-4 flex justify-between items-center">
					<h1 className="text-2xl font-semibold">Dashboard</h1>
					<div className="h-10 w-10 rounded-full bg-gray-300"></div>
				</header>

				{/* Stats Cards */}
				<div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
					<div className="bg-white p-5 rounded-xl shadow">
						<h2 className="text-gray-600">Users</h2>
						<p className="text-3xl font-bold">1,245</p>
					</div>

					<div className="bg-white p-5 rounded-xl shadow">
						<h2 className="text-gray-600">Sales</h2>
						<p className="text-3xl font-bold">₹84,500</p>
					</div>

					<div className="bg-white p-5 rounded-xl shadow">
						<h2 className="text-gray-600">Tickets</h2>
						<p className="text-3xl font-bold">73</p>
					</div>

					<div className="bg-white p-5 rounded-xl shadow">
						<h2 className="text-gray-600">Pending Tasks</h2>
						<p className="text-3xl font-bold">12</p>
					</div>
				</div>

				{/* Table Section */}
				<div className="p-6">
					<div className="bg-white rounded-xl shadow p-5">
						<h2 className="text-xl font-semibold mb-4">Recent Transactions</h2>

						<table className="w-full text-left border-collapse">
							<thead>
								<tr className="bg-gray-100">
									<th className="p-3 border">ID</th>
									<th className="p-3 border">Name</th>
									<th className="p-3 border">Amount</th>
									<th className="p-3 border">Status</th>
								</tr>
							</thead>

							<tbody>
								<tr>
									<td className="p-3 border">1</td>
									<td className="p-3 border">Amit Sharma</td>
									<td className="p-3 border">₹2,500</td>
									<td className="p-3 border text-green-600">Completed</td>
								</tr>
								<tr>
									<td className="p-3 border">2</td>
									<td className="p-3 border">Neha Verma</td>
									<td className="p-3 border">₹1,100</td>
									<td className="p-3 border text-yellow-600">Pending</td>
								</tr>
								<tr>
									<td className="p-3 border">3</td>
									<td className="p-3 border">Rahul Patil</td>
									<td className="p-3 border">₹4,750</td>
									<td className="p-3 border text-red-600">Failed</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
